import * as React from "react";
import { ComponentProps } from "react";
import AR from "./svg/AR.svg?react";
import C2 from "./svg/C2.svg?react";
import C3 from "./svg/C3.svg?react";
import C4 from "./svg/C4.svg?react";
import CC from "./svg/CC.svg?react";
import CP from "./svg/CP.svg?react";
import CT from "./svg/CT.svg?react";
import FP from "./svg/FP.svg?react";
import FT from "./svg/FT.svg?react";
import G1 from "./svg/G1.svg?react";
import G2 from "./svg/G2.svg?react";
import HB from "./svg/HB.svg?react";
import LO from "./svg/LO.svg?react";
import R2 from "./svg/R2.svg?react";
import R4 from "./svg/R4.svg?react";
import RE from "./svg/RE.svg?react";
import RI from "./svg/RI.svg?react";
import RT from "./svg/RT.svg?react";
import S1 from "./svg/S1.svg?react";
import S2 from "./svg/S2.svg?react";
import SI from "./svg/SI.svg?react";
import SU from "./svg/SU.svg?react";
import T1 from "./svg/T1.svg?react";
import T2 from "./svg/T2.svg?react";
import T3 from "./svg/T3.svg?react";
import T4 from "./svg/T4.svg?react";
import T5 from "./svg/T5.svg?react";
import U1 from "./svg/U1.svg?react";
import U2 from "./svg/U2.svg?react";
import U3 from "./svg/U3.svg?react";
import U4 from "./svg/U4.svg?react";
import VA from "./svg/VA.svg?react";
import TR from "./svg/TR.svg?react";
import U5 from "./svg/TR.svg?react";
import ALL from "./svg/ALL.svg?react";

interface Props {
  vehicleTypeCode?: string | undefined;
}

export const VehicleTypeIcon: React.FC<Props> = ({ vehicleTypeCode }) => {
  const svgProps: ComponentProps<typeof AR> = {
    height: "32px",
    width: "32px",
  };

  switch (vehicleTypeCode) {
    case "AR":
      return <AR {...svgProps} />;
    case "C2":
      return <C2 {...svgProps} />;
    case "C3":
      return <C3 {...svgProps} />;
    case "C4":
      return <C4 {...svgProps} />;
    case "CC":
      return <CC {...svgProps} />;
    case "CP":
      return <CP {...svgProps} />;
    case "CT":
      return <CT {...svgProps} />;
    case "FP":
      return <FP {...svgProps} />;
    case "FT":
      return <FT {...svgProps} />;
    case "G1":
      return <G1 {...svgProps} />;
    case "G2":
      return <G2 {...svgProps} />;
    case "HB":
      return <HB {...svgProps} />;
    case "LO":
      return <LO {...svgProps} />;
    case "R2":
      return <R2 {...svgProps} />;
    case "R4":
      return <R4 {...svgProps} />;
    case "RE":
      return <RE {...svgProps} />;
    case "RI":
      return <RI {...svgProps} />;
    case "RT":
      return <RT {...svgProps} />;
    case "S1":
      return <S1 {...svgProps} />;
    case "S2":
      return <S2 {...svgProps} />;
    case "SI":
      return <SI {...svgProps} />;
    case "SU":
      return <SU {...svgProps} />;
    case "T1":
      return <T1 {...svgProps} />;
    case "T2":
      return <T2 {...svgProps} />;
    case "T3":
      return <T3 {...svgProps} />;
    case "T4":
      return <T4 {...svgProps} />;
    case "T5":
      return <T5 {...svgProps} />;
    case "TR":
      return <TR {...svgProps} />;
    case "U1":
      return <U1 {...svgProps} />;
    case "U2":
      return <U2 {...svgProps} />;
    case "U3":
      return <U3 {...svgProps} />;
    case "U4":
      return <U4 {...svgProps} />;
    case "U5":
      return <U5 {...svgProps} />;
    case "VA":
      return <VA {...svgProps} />;
    case undefined:
      return <ALL {...svgProps} />;
    default:
      return <></>;
  }
};
